import { EncodeObject, GeneratedType } from '@cosmjs/proto-signing';
import { MsgSwapExactAmountIn } from './ts-client/tx_swap';
import { MsgJoinPool, MsgJoinSwapExternAmountIn, MsgExitPool } from './ts-client/tx_liquidity';
import { MsgCreateBalancerPool } from './ts-client/pool-models/balancer/tx';

export const ammTypes: ReadonlyArray<[ string, GeneratedType ]> = [
  [ '/dymensionxyz.dymension.gamm.v1beta1.MsgSwapExactAmountIn', MsgSwapExactAmountIn ],
  [ '/dymensionxyz.dymension.gamm.v1beta1.MsgJoinPool', MsgJoinPool ],
  [ '/dymensionxyz.dymension.gamm.v1beta1.MsgJoinSwapExternAmountIn', MsgJoinSwapExternAmountIn ],
  [ '/dymensionxyz.dymension.gamm.v1beta1.MsgExitPool', MsgExitPool ],
  [ '/dymensionxyz.dymension.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool', MsgCreateBalancerPool ],
];

export interface MsgSwapExactAmountInEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.gamm.v1beta1.MsgSwapExactAmountIn';
  readonly value: Partial<MsgSwapExactAmountIn>;
}

export interface MsgJoinPoolEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.gamm.v1beta1.MsgJoinPool';
  readonly value: Partial<MsgJoinPool>;
}

export interface MsgJoinSwapExternAmountInEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.gamm.v1beta1.MsgJoinSwapExternAmountIn';
  readonly value: Partial<MsgJoinSwapExternAmountIn>;
}

export interface MsgExitPoolEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.gamm.v1beta1.MsgExitPool';
  readonly value: Partial<MsgExitPool>;
}

export interface MsgCreateBalancerPoolEncodeObject extends EncodeObject {
  readonly typeUrl: '/dymensionxyz.dymension.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool';
  readonly value: Partial<MsgCreateBalancerPool>;
}

export function isMsgSwapExactAmountInEncodeObject(object: EncodeObject): object is MsgSwapExactAmountInEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.gamm.v1beta1.MsgSwapExactAmountIn';
}

export function isMsgJoinPoolEncodeObject(object: EncodeObject): object is MsgJoinPoolEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.gamm.v1beta1.MsgJoinPool';
}

export function isMsgJoinSwapExternAmountInEncodeObject(object: EncodeObject): object is MsgJoinSwapExternAmountInEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.gamm.v1beta1.MsgJoinSwapExternAmountIn';
}

export function isMsgExitPoolEncodeObject(object: EncodeObject): object is MsgExitPoolEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.gamm.v1beta1.MsgExitPool';
}

export function isMsgCreateBalancerPoolEncodeObject(object: EncodeObject): object is MsgCreateBalancerPoolEncodeObject {
  return object.typeUrl === '/dymensionxyz.dymension.gamm.poolmodels.balancer.v1beta1.MsgCreateBalancerPool';
}






